(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mercat-viewer-badge"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();

  function setupViewerDemos(root) {
    const containers = [];
    if (root.matches && root.matches('[data-mercat-viewer-demo]')) containers.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-mercat-viewer-demo]').forEach(el => containers.push(el));
    }
    containers.forEach(el => {
      if (initialized.has(el)) return;
      const label = el.querySelector('[data-mercat-viewer-number]');
      const counts = (el.dataset.viewerSequence || '').split(',').map(Number);
      const cycle = Number(el.dataset.cycleMs) || 80000;
      if (!label || counts.length !== 10 || counts.some(n => !Number.isFinite(n))) return;
      initialized.add(el);
      const beginning = Date.now();
      const word = label.textContent.trim().replace(/^\d+\s*/, '');
      let previous = -1;
      const tick = () => {
        if (!el.isConnected) {
          clearInterval(timer);
          return;
        }
        const elapsed = (Date.now() - beginning) % cycle;
        const stage = Math.floor(elapsed / 8000) % counts.length;
        if (stage !== previous) {
          previous = stage;
          label.textContent = counts[stage] + ' ' + word;
        }
      };
      const timer = setInterval(tick, 250);
      tick();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupViewerDemos(document), { once:true });
  } else {
    setupViewerDemos(document);
  }
  document.addEventListener('shopify:section:load', event => setupViewerDemos(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
